export function responseAtPath(value: any, path: string): any {
  return String(path || '').split('.').filter(Boolean).reduce((item, key) => item?.[key], value);
}

export function buildWaterfallOption(config: any, records: any[]): any {
  const source = config.dataSource;
  const style = config.waterfall;
  let running = 0;
  let matched = false;
  const steps = config.categories.map((category: any) => {
    if (category.type === 'total') return { ...category, start: 0, end: running, value: running };
    const start = running;
    const matching = records.filter(record => category.values.includes(String(record[source.fields.category])));
    if (matching.length) matched = true;
    const value = matching.reduce((sum, record) => {
      const raw = record[source.fields.value];
      if (raw == null || String(raw).trim() === '' || !Number.isFinite(Number(raw))) throw new Error('Invalid investment');
      return sum + Number(raw);
    }, 0);
    running += value;
    return { ...category, start, end: running, value };
  });
  if (!matched) throw new Error('No matching categories');
  const format = (value: number) => new Intl.NumberFormat(config.numberFormat.locale, {
    maximumFractionDigits: config.numberFormat.decimals,
  }).format(value);
  const options = config.chartOptions || {};
  return {
    ...options,
    aria: {
      enabled: true,
      label: { description: steps.map((step: any) => `${step.label}: ${format(step.value)} ${style.unit || ''}`).join('. ') },
      ...options.aria,
    },
    tooltip: {
      trigger: 'axis', renderMode: 'richText', axisPointer: { type: 'shadow' },
      formatter: (params: any[]) => {
        const item = params.find(param => param.data?.rawValue !== undefined);
        return item ? `${item.name}\n${format(item.data.rawValue)} ${style.unit}` : '';
      },
      ...options.tooltip,
    },
    xAxis: { type: 'category', ...options.xAxis, data: steps.map((step: any) => step.label) },
    yAxis: { type: 'value', ...options.yAxis },
    series: [
      {
        type: 'bar', stack: 'waterfall', stackStrategy: 'all', silent: true,
        itemStyle: { color: 'transparent' }, emphasis: { disabled: true }, tooltip: { show: false },
        data: steps.map((step: any) => Math.min(step.start, step.end)),
      },
      {
        name: style.seriesName, type: 'bar', stack: 'waterfall', stackStrategy: 'all', barWidth: style.barWidth,
        itemStyle: { color: style.barColor },
        emphasis: style.emphasis,
        label: { show: true, fontSize: style.valueFontSize },
        data: steps.map((step: any) => ({
          value: Math.abs(step.end - step.start), rawValue: step.value,
          itemStyle: { color: step.color || style.barColor },
          label: {
            position: step.labelPosition === 'inside' ? 'inside' : 'top',
            color: step.labelPosition === 'inside' ? style.insideLabelColor : style.labelColor,
            formatter: () => format(step.value),
          },
        })),
        markArea: {
          silent: true, label: { show: false }, itemStyle: { color: style.highlightColor },
          data: steps.filter((step: any) => step.highlight).map((step: any) => [{ xAxis: step.label }, { xAxis: step.label }]),
        },
      },
      {
        type: 'line', data: [], silent: true, tooltip: { show: false },
        markLine: {
          silent: true, symbol: ['none', 'none'], label: { show: false },
          lineStyle: { color: style.connector.color, type: style.connector.type, width: style.connector.width },
          data: style.connector.show ? steps.slice(0, -1).map((step: any, index: number) => [
            { coord: [index, step.end] }, { coord: [index + 1, step.end] },
          ]) : [],
        },
      },
    ],
  };
}
